export default "__VITE_ASSET__Duydx33n__"